import paronApi from '@/utils/paron-api'

export default {
    getAllSports(page = 1, perPage = 60) {
        return paronApi.get(`sport/all?page=${page}&per_page=${perPage}`)
    },

    getSportById(id) {
        return paronApi.get(`sport/${id}`)
    },

    createSport(data) {
        return paronApi.uploadFile('sport/new', data)
    },

    editSportById(id, data) {
        return paronApi.uploadFile(`sport/${id}/edit`, data)
    },

    deleteSportById(id) {
        return paronApi.delete(`sport/${id}`)
    }

}
